import { render, staticRenderFns } from "./wigs-details-print-page.vue?vue&type=template&id=7589b4ec&scoped=true"
import script from "./wigs-details-print-page.vue?vue&type=script&lang=js"
export * from "./wigs-details-print-page.vue?vue&type=script&lang=js"
import style0 from "./wigs-details-print-page.vue?vue&type=style&index=0&id=7589b4ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589b4ec",
  null
  
)

export default component.exports